import { useEffect, useState } from 'react'

import InfoDetails from '../components/InfoDetails'
import Page from '../components/Page'
import { Tabs } from '../components/Tabs'
import { useUserContext } from '../shared/user'

const Home = () => {
	const [details, setDetails] = useState([])

	const { user, loading } = useUserContext()

	const mapDetails = (res) => {
		return [
			{
				title: 'Weergavenaam',
				value: res.fullName,
			},
			{
				title: 'Voornaam',
				value: res.firstName,
			},
			{
				title: 'Achternaam',
				value: res.lastName,
			},
			{
				title: 'Emailadres',
				value: res.email,
			},
			{
				title: 'Omschrijving',
				value: res.description,
			},
			{
				title: 'Laatst mislukte inlogpoging',
				value: new Date(res.lastFailedLogin).toLocaleString(),
			},
			{
				title: 'Laatste wachtwoord wijziging',
				value: new Date(res.lastPasswordChange).toLocaleString(),
			},
		]
	}

	useEffect(() => {
		setDetails(mapDetails(user))
	}, [user])

	const tabItems = [
		{
			title: 'Algemeen',
			content: <InfoDetails details={details} />,
		},
	]

	return (
		<Page title='Accountgegevens' loading={loading}>
			<Tabs items={tabItems} className='mt-3' />
		</Page>
	)
}

export default Home
